import { ICrmSurveyResponseVm } from "../models/response/crm-survey/ICrmSurveyResponse";
import { apiClient } from "./apiClient";

export const crmSurveyResponseApi = {
    selectAll: () => apiClient.get(`crm_survey-respone`),
    selectDetail: (id: number) => apiClient.get(`crm_survey-respone/${id}`),
    saveChanges: (data: ICrmSurveyResponseVm) => apiClient.post(`crm_survey-respone`, data),
    delete: (id: number) => apiClient.delete(`crm_survey-respone/${id}`),
}